<script setup>
import { useUi } from '@/stores/ui.js'
import UiModal from './UiModal.vue'
import UiButton from './UiButton.vue'

const ui = useUi()
</script>

<template>
  <UiModal :open="!!ui.confirm" :title="ui.confirm?.title || $t('common.confirm')" size="sm" @close="ui.answer(false)">
    <!-- a question names what it is about (a person, a record): masked in privacy mode, as a toast is (D-260) -->
    <p v-private class="whitespace-pre-line text-sm">{{ ui.confirm?.message }}</p>
    <template #footer>
      <UiButton data-testid="confirm-cancel" @click="ui.answer(false)">{{ $t('common.cancel') }}</UiButton>
      <UiButton :variant="ui.confirm?.danger ? 'danger' : 'primary'" data-testid="confirm-ok" @click="ui.answer(true)">{{ ui.confirm?.confirmLabel || $t('common.confirm') }}</UiButton>
    </template>
  </UiModal>
</template>
